import { render, staticRenderFns } from "./NotificationFeed.vue?vue&type=template&id=61c8bdcb&scoped=true&"
import script from "./NotificationFeed.vue?vue&type=script&lang=js&"
export * from "./NotificationFeed.vue?vue&type=script&lang=js&"
import style0 from "./NotificationFeed.vue?vue&type=style&index=0&id=61c8bdcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8bdcb",
  null
  
)

export default component.exports